<script setup lang="ts">
import TimeTracker from "./components/TimeTracker/index.vue";
import PrivacyDialog from "./components/PrivacyDialog.vue";
import { onMounted, ref } from "vue";
import { posthogService } from "./services/posthogService";

// Privacy dialog state
const showPrivacyDialog = ref(false);

// Initialize PostHog Analytics
onMounted(() => {
  // Check if this is the first visit
  const hasSeenPrivacyNotice = localStorage.getItem("privacy-notice-seen");

  if (!hasSeenPrivacyNotice) {
    // Show privacy dialog on first visit
    showPrivacyDialog.value = true;
    localStorage.setItem("privacy-notice-seen", "true");
    // Don't track page view or initialize PostHog until user makes choice
  } else {
    // Initialize analytics if user hasn't opted out
    posthogService.initialize();

    // Track initial page view only after initialization
    posthogService.trackPageView();
  }

  // Track navigation in SPA
  const trackPageView = () => {
    posthogService.trackPageView();
  };

  window.addEventListener("popstate", trackPageView);
});

function closePrivacyDialog() {
  showPrivacyDialog.value = false;
  // Initialize analytics after user has made their choice
  posthogService.initialize();

  // Track page view after initialization
  posthogService.trackPageView();
}
</script>

<template>
  <div class="app">
    <TimeTracker />

    <!-- Privacy Dialog -->
    <PrivacyDialog :is-open="showPrivacyDialog" @close="closePrivacyDialog" />
  </div>
</template>

<style>
.app {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
